import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { Product } from "./Product";
/**
 * Product compatibility class
 */

export class ProductCompatibility extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getCategories = () => {
      return this.model.categories || [];
    };

    this.getProducts = products => {
      return this.getRelation('products', Product, products, true);
    };
  }

  /**
   * Create product compatibility
   *
   * @param {object} object
   *
   * @return {ProductCompatibility}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list product compatibility
   *
   * @param {object} objects
   *
   * @return {Array.<ProductCompatibility>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map product compatibility
   *
   * @param {Array.<object>} objects
   * @param {function(ProductCompatibility): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get compatibility categories
   *
   * @returns {*|Array}
   */


}